// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CookieModal-Container {
  position: fixed;
  bottom: 0;
  z-index: 1100;
  padding: 3rem;
  width: 100%;
  background-color: rgba(43, 43, 43, 0.64);
  color: #fff;
}
@media screen and (max-width: 800px) {
  .CookieModal-Container {
    padding-right: 20px;
    padding-left: 20px;
  }
}
@media screen and (max-width: 1823px) {
  .CookieModal-Container {
    padding-right: 40px;
    padding-left: 40px;
  }
}
@media screen and (min-width: 1824px) {
  .CookieModal-Container {
    margin: auto !important;
    padding-right: 8.8125rem;
    padding-left: 8.8125rem;
  }
}

.CookieModal-Heading {
  font-weight: bold;
  font-size: 60px;
}
@media screen and (max-width: 800px) {
  .CookieModal-Heading {
    font-size: 24px;
  }
}

.CookieModal-Footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 2rem;
}

.CookieModal-Button {
  margin: 0 0.5rem;
  padding: 7px 32px 2px;
  border: none;
  border-radius: 24px;
  background: rgba(43, 43, 43, 0.4);
  font-weight: bold;
  font-size: 24px;
}
.CookieModal-Button:hover, .CookieModal-Button:active, .CookieModal-Button:focus, .CookieModal-Button:visited, .CookieModal-Button:focus-within, .CookieModal-Button:disabled {
  border: none !important;
  background-color: rgb(43, 43, 43) !important;
  box-shadow: none !important;
}
.CookieModal-Button.Primary {
  background: #317af6;
}
.CookieModal-Button.Primary:hover, .CookieModal-Button.Primary:active, .CookieModal-Button.Primary:focus, .CookieModal-Button.Primary:visited, .CookieModal-Button.Primary:focus-within, .CookieModal-Button.Primary:disabled {
  border: none !important;
  background-color: #317af6 !important;
  box-shadow: none !important;
}
@media screen and (max-width: 800px) {
  .CookieModal-Button {
    margin: 0.5rem;
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/CookieModal.scss","webpack://./src/assets/scss/helpers/_variable.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,SAAA;EACA,aCmDkB;EDlDlB,aAAA;EACA,WAAA;EACA,wCAAA;EACA,WCCM;ADFR;AAEE;EARF;IASI,mBAAA;IACA,kBAAA;EACF;AACF;AACE;EAbF;IAcI,mBAAA;IACA,kBAAA;EAEF;AACF;AAAE;EAlBF;IAmBI,uBAAA;IACA,wBAAA;IACA,uBAAA;EAGF;AACF;;AAAA;EACE,iBAAA;EACA,eAAA;AAGF;AADE;EAJF;IAKI,eAAA;EAIF;AACF;;AADA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAIF;;AAFA;EACE,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,iCAAA;EACA,iBAAA;EACA,eAAA;AAKF;AAJE;EAME,uBAAA;EACA,4CAAA;EACA,2BAAA;AACJ;AACE;EACE,mBCvDG;ADwDP;AAAI;EAME,uBAAA;EACA,oCAAA;EACA,2BAAA;AAHN;AAME;EA/BF;IAgCI,cAAA;IACA,eAAA;EAHF;AACF","sourcesContent":["@import '../../assets/scss//helpers/component';\n\n.CookieModal-Container {\n  position: fixed;\n  bottom: 0;\n  z-index: $zi-cookie-overlay;\n  padding: 3rem;\n  width: 100%;\n  background-color: rgba(43, 43, 43, 0.64);\n  color: $white;\n  @media screen and (max-width: 800px) {\n    padding-right: 20px;\n    padding-left: 20px;\n  }\n\n  @media screen and (max-width: 1823px) {\n    padding-right: 40px;\n    padding-left: 40px;\n  }\n\n  @media screen and (min-width: 1824px) {\n    margin: auto !important;\n    padding-right: rem(141px);\n    padding-left: rem(141px);\n  }\n}\n\n.CookieModal-Heading {\n  font-weight: bold;\n  font-size: 60px;\n\n  @media screen and (max-width: 800px) {\n    font-size: 24px;\n  }\n}\n\n.CookieModal-Footer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  margin-top: 2rem;\n}\n.CookieModal-Button {\n  margin: 0 0.5rem;\n  padding: 7px 32px 2px;\n  border: none;\n  border-radius: 24px;\n  background: rgba(43, 43, 43, 0.4);\n  font-weight: bold;\n  font-size: 24px;\n  &:hover,\n  &:active,\n  &:focus,\n  &:visited,\n  &:focus-within,\n  &:disabled {\n    border: none !important;\n    background-color: rgba(43, 43, 43, 1) !important;\n    box-shadow: none !important;\n  }\n  &.Primary {\n    background: $blue;\n    &:hover,\n    &:active,\n    &:focus,\n    &:visited,\n    &:focus-within,\n    &:disabled {\n      border: none !important;\n      background-color: $blue !important;\n      box-shadow: none !important;\n    }\n  }\n  @media screen and (max-width: 800px) {\n    margin: 0.5rem;\n    font-size: 16px;\n  }\n}\n","// Fonts colors\n$primary: #415a77;\n$secondary: #2e2e3a;\n$header-background: #415a77;\n$primary-green: #2afca3;\n$light-grey: #f1f4fb;\n$blue: #317af6;\n$light-blue: #89b8f1;\n$light-green: #8ebbf1;\n$border-light: #d3e1fd;\n$white: #fff;\n$sky-blue: #cad8f2;\n$green: #3cc221;\n$red: #f42b03;\n$golden: #ffe13e;\n$pink: #fd6383;\n$dark-blue: #405873;\n$dark-blue-active: #35485e;\n$pale-grey: #f8fafd;\n$table-border: #c5d5f4;\n$highlight-text-color: #2b2b2b;\n$black: #000000;\n$accent4: #fab723;\n$maroon: #bb0611;\n$dark-blue-link: #263546;\n\n\n$gbp-rich-green: #003825;\n$gbp-electric-green: #00ff7f;\n$gbp-blue: #00a4ff;\n\n$table-border: $gbp-electric-green;\n\n$font-family-base: 'MADETOMMY', Arial, sans-serif;\n$font-family-alt: 'HeadingPro', Arial, sans-serif;\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  // xxl: 1440px,\n  // xxxl: 1600px\n);\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  // xxl: 1440px,\n  // xxxl: 1600px\n);\n\n\n$zi-header: 1000;\n$zi-cookie-overlay: 1100;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
